import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Tab.scss';

function Tab({ label, active, handleTabClick }) {
  function onClick(event) {
    event.preventDefault();
    handleTabClick();
  }
  return (
    <div
      style={{ borderRadius: '4px 4px 0 0' }}
      className={classNames(
      'ui-tabs__tab',
      'ui-tabs__tab_min',
      { 'ui-tabs__tab_selected': active },
    )}
    >
      <a
        className={classNames(
          styles.link,
          { active },
        )}
        onClick={onClick}
        href="#"
      >
        <span className="ui-tabs__label">{label}</span>
      </a>
    </div>
  );
}

Tab.propTypes = {
  label: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
};

export default Tab;

